/**
 * Path builders for the guest's instant room block pages under the event handle.
 *
 * The guest app may not import from `@apps/admin`, so the guest side builds its own paths. The booking
 * and checkout paths already start with `/${eventHandle}`; the hotel page path is root-relative. Callers
 * use each path as it is and do not prefix it with `buildPath`.
 */

/** The path segment after the event handle. `CARBON_KEPT_GUEST_SUBPATHS` (`src/server/utils/carbonGuestSite.ts`) lists it too. */
export const INSTANT_ROOM_BLOCK_BOOKING_PATH_SEGMENT = 'instant-room-block';

/** The route pattern `Guest.tsx` registers. The claim checkout is this pattern plus `/checkout`. */
export const INSTANT_ROOM_BLOCK_GUEST_ROUTE_PATH = `/:eventHandle/${INSTANT_ROOM_BLOCK_BOOKING_PATH_SEGMENT}/:instantRoomBlockId`;

/** The booking link page: `/${eventHandle}/instant-room-block/${instantRoomBlockId}`. */
export const buildInstantRoomBlockBookingLinkPath = (eventHandle: string, instantRoomBlockId: string): string =>
  `/${encodeURIComponent(eventHandle)}/${INSTANT_ROOM_BLOCK_BOOKING_PATH_SEGMENT}/${encodeURIComponent(instantRoomBlockId)}`;

/** The claim checkout: the booking link page's path with `/checkout` appended. */
export const buildInstantRoomBlockClaimCheckoutPath = (eventHandle: string, instantRoomBlockId: string): string =>
  `${buildInstantRoomBlockBookingLinkPath(eventHandle, instantRoomBlockId)}/checkout`;

/** The hotel's stays page: `/stays/${joyPlaceId}?eventId=${eventId}` (requires Postgres eventId). */
export const buildInstantRoomBlockHotelPagePath = (joyPlaceId: string, eventId: string): string =>
  `/stays/${encodeURIComponent(joyPlaceId)}?eventId=${encodeURIComponent(eventId)}`;
